export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";

// Maximum date for document expiry - year 9999 is Python's datetime maximum year limit
export const MAX_DOCUMENT_EXPIRY_DATE = new Date(9999, 11, 31);

interface DATE_FORMAT_TYPE {
  long: string;
  short: string;
  shorts: string[];
}

export type DATE_TYPE = "long" | "short";

interface DATE_FORMATS_TYPE {
  [index: string]: DATE_FORMAT_TYPE;
}

export const DATE_FORMATS: DATE_FORMATS_TYPE = {
  "MM/DD/YYYY": {
    long: "MMM d, yyyy",
    short: "MM/dd/yyyy",
    shorts: [
      "MM/dd/yyyy",
      "M/d/yyyy",
      "MM/d/yyyy",
      "M/dd/yyyy",
      "MM/dd/yy",
      "M/d/yy",
      "MM/d/yy",
      "M/dd/yy",
    ],
  },
  "DD/MM/YYYY": {
    long: "d MMM yyyy",
    short: "dd/MM/yyyy",
    shorts: [
      "dd/MM/yyyy",
      "d/M/yyyy",
      "d/MM/yyyy",
      "dd/M/yyyy",
      "dd/MM/yy",
      "d/M/yy",
      "d/MM/yy",
      "dd/M/yy",
    ],
  },
  "YYYY-MM-DD": {
    long: "yyyy-MM-dd",
    short: "yyyy-MM-dd",
    shorts: [
      "yyyy-MM-dd",
      "yyyy-M-d",
      "yyyy-MM-d",
      "yyyy-M-dd",
      "yy-MM-dd",
      "yy-M-d",
      "yy-MM-d",
      "yy-M-dd",
    ],
  },
};

/**
 * Validation regex patterns
 */

/**
 * Email domain validation pattern
 * Validates domain format with required TLD (e.g., domain.com, mail.example.in)
 * - Allows alphanumeric characters
 * - Allows dots and hyphens as separators
 * - Requires at least 2 character TLD
 */
export const EMAIL_DOMAIN_REGEX = /^[a-z0-9]+([.-][a-z0-9]+)*\.[a-z]{2,}$/i;

/**
 * Arena domain validation pattern
 * Validates domain format without underscores
 * - Allows alphanumeric characters
 * - Allows dots and hyphens as separators
 * - No underscores allowed
 */
export const ARENA_DOMAIN_REGEX = /^[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*$/;

/**
 * JSQ Object Types
 * These represent different object types in the JSQ platform
 */
export enum JSQ_OBJECT_TYPE {
  ENTITY = 6,
}
